import { useGlobalFilters } from '@/hooks/useGlobalFilters';
import { useEffect } from 'react';

function GlobalStates({ brandsList }) {
  const { setAllowedAccessBrands } = useGlobalFilters();

  useEffect(() => {
    setAllowedAccessBrands(brandsList);
  }, [brandsList, setAllowedAccessBrands]);

  return <></>;
}

export default GlobalStates;
